module.exports = new __parcel__URL__("macintosh-human-interface-guidelines.67bb3c69.jpg").toString();